import script from "./BooksDone.vue?vue&type=script&setup=true&lang=ts"
export * from "./BooksDone.vue?vue&type=script&setup=true&lang=ts"

import "./BooksDone.vue?vue&type=style&index=0&id=ac635254&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac635254"]])

export default __exports__